<form [formGroup]="form">
  <section>
    <h3 class="section-title">
      {{
        "publicationTemplate.create.googlePerformanceMaxAd.images.title"
          | translate
      }}
    </h3>
    <span class="section-description">
      {{
        "publicationTemplate.create.googlePerformanceMaxAd.images.description"
          | translate
      }}
    </span>
    <div class="images-grid">
      <app-multiple-image-or-video-uploader
        [type]="type"
        [control]="form.controls.images"
        [form]="form"
        [fields]="fields"
        [maxNumFiles]="20"
        [availableNumFiles]="20 - (form.controls.images.value?.length ?? 0)"
      />
      @for (image of form.controls.images.value; track $index) {
        <app-media-preview
          [media]="image"
          (remove)="onActionDeleteMedia(form.controls.images, $index)"
        />
      }
    </div>
    @if (
      !form.untouched &&
      (form.controls.images.errors?.minElements ||
        form.controls.images.errors?.maxElements)
    ) {
      <app-error-message key="The number of image must be between 1 and 20" />
    }
  </section>

  <section>
    <h3 class="section-title">
      {{
        "publicationTemplate.create.googlePerformanceMaxAd.logo.title"
          | translate
      }}
    </h3>
    <app-single-image-or-video-uploader
      [type]="type"
      [control]="form.controls.logo"
      [form]="form"
      [fields]="fields"
      [brandId]="brandId"
    />
  </section>

  <section>
    <h3 class="section-title">
      {{
        "publicationTemplate.create.googlePerformanceMaxAd.videos.title"
          | translate
      }}
    </h3>
    <span class="section-description">
      {{
        "publicationTemplate.create.googlePerformanceMaxAd.images.description"
          | translate
      }}
    </span>
    <div class="images-grid">
      <app-multiple-image-or-video-uploader
        [type]="type"
        [control]="form.controls.videos"
        [form]="form"
        [fields]="fields"
        [maxNumFiles]="5"
        [availableNumFiles]="5 - (form.controls.videos.value?.length ?? 0)"
      />
      @for (video of form.controls.videos.value; track $index) {
        <app-media-preview
          [media]="video"
          (remove)="onActionDeleteMedia(form.controls.videos, $index)"
        />
      }
    </div>
    @if (
      !form.untouched &&
      (form.controls.videos.errors?.minElements ||
        form.controls.videos.errors?.maxElements)
    ) {
      <app-error-message key="The number of image must be between 1 and 5" />
    }
  </section>

  <section>
    <h3 class="section-title">
      {{
        "publicationTemplate.create.googlePerformanceMaxAd.targetUrl.title"
          | translate
      }}
    </h3>
    <app-publication-template-link-selector [form]="form" [maxLength]="60" />
  </section>

  <section>
    <h3 class="section-title">
      {{
        "publicationTemplate.create.googlePerformanceMaxAd.headline.title"
          | translate
      }}
    </h3>
    <span class="section-description">
      {{
        "publicationTemplate.create.googlePerformanceMaxAd.headline.description"
          | translate
      }}
    </span>
    <div class="field-list">
      @for (control of form.controls.headlines.controls; track $index) {
        <div class="field">
          <mat-form-field>
            <mat-label>
              {{
                "publicationTemplate.create.googlePerformanceMaxAd.headline.placeholder"
                  | translate
              }}
              {{ $index + 1 }}
            </mat-label>
            <input matInput [formControl]="control" />
            <mat-hint align="end">
              {{ control.value?.length ?? 0 }} characters of (30 maximum)
            </mat-hint>
          </mat-form-field>
          @if ($index >= minNumHeadlines) {
            <button
              class="btn--content-only btn-close"
              (click)="form.controls.headlines.removeAt($index)"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      }
    </div>
    <button
      class="btn btn--border-only"
      [disabled]="form.controls.headlines.controls.length >= maxNumHeadlines"
      (click)="addTextControl(form.controls.headlines)"
    >
      <mat-icon>add</mat-icon
      >{{
        "publicationTemplate.create.googlePerformanceMaxAd.headline.add"
          | translate
      }}
    </button>
  </section>

  <section>
    <h3 class="section-title">
      {{
        "publicationTemplate.create.googlePerformanceMaxAd.longHeadline.title"
          | translate
      }}
    </h3>
    <span class="section-description">
      {{
        "publicationTemplate.create.googlePerformanceMaxAd.longHeadline.description"
          | translate
      }}
    </span>
    <div class="field-list">
      @for (control of form.controls.longHeadlines.controls; track $index) {
        <div class="field">
          <mat-form-field>
            <mat-label>
              {{
                "publicationTemplate.create.googlePerformanceMaxAd.longHeadline.placeholder"
                  | translate
              }}
              {{ $index + 1 }}
            </mat-label>
            <input matInput [formControl]="control" />
            <mat-hint align="end">
              {{ control.value?.length ?? 0 }} characters of (30 maximum)
            </mat-hint>
          </mat-form-field>
          @if ($index >= minNumLongHeadlines) {
            <button
              class="btn--content-only btn-close"
              (click)="form.controls.longHeadlines.removeAt($index)"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      }
    </div>
    <button
      class="btn btn--border-only"
      [disabled]="
        form.controls.longHeadlines.controls.length >= maxNumLongHeadlines
      "
      (click)="addTextControl(form.controls.longHeadlines)"
    >
      <mat-icon>add</mat-icon
      >{{
        "publicationTemplate.create.googlePerformanceMaxAd.longHeadline.add"
          | translate
      }}
    </button>
  </section>

  <section>
    <h3 class="section-title">
      {{
        "publicationTemplate.create.googlePerformanceMaxAd.description.title"
          | translate
      }}
    </h3>
    <span class="section-description">
      {{
        "publicationTemplate.create.googlePerformanceMaxAd.description.description"
          | translate
      }}
    </span>
    <div class="field-list">
      @for (control of form.controls.descriptions.controls; track $index) {
        <div class="field">
          <mat-form-field>
            <mat-label>
              {{
                "publicationTemplate.create.googlePerformanceMaxAd.description.placeholder"
                  | translate
              }}
              {{ $index + 1 }}
            </mat-label>
            <input matInput [formControl]="control" />
            <mat-hint align="end">
              {{ control.value?.length ?? 0 }} characters of (30 maximum)
            </mat-hint>
          </mat-form-field>
          @if ($index >= minNumDescriptions) {
            <button
              class="btn--content-only btn-close"
              (click)="form.controls.descriptions.removeAt($index)"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      }
    </div>
    <button
      class="btn btn--border-only"
      [disabled]="
        form.controls.descriptions.controls.length >= maxNumDescriptions
      "
      (click)="addTextControl(form.controls.descriptions)"
    >
      <mat-icon>add</mat-icon
      >{{
        "publicationTemplate.create.googlePerformanceMaxAd.description.add"
          | translate
      }}
    </button>
  </section>
</form>
